import _objectSpread from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import info from '@/api/info';
import { $formErr, $getInfo, $rdoLang } from '@/assets/common/common.js';
import { useLang } from '@/hooks/lang';
import { XlButton, XlCountDown, XlDialog, XlInput, XlMessage } from '@shining3d/ui-components';
import XLCaptcha from '@shining3d/captacha';
import { VueCookieNext } from 'vue-cookie-next';
import confirmDialog from './confirm-dialog.vue';
export default {
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var _useLang = useLang('@shining3d/app'),
      $t = _useLang.$t;
    var dialogVisible = ref(false);
    var submitLoading = ref(false);
    var formRef = ref(false);
    var rules = ref({
      username: [{
        required: true,
        message: $t('rules.notEmpty'),
        trigger: 'blur'
      }],
      validCode: [{
        required: true,
        message: $t('rules.notEmpty'),
        trigger: 'blur'
      }]
    });
    var form = ref({
      phoneArea: '',
      uuid: 'dental-emailbind-' + VueCookieNext.getCookie('user_id'),
      captcha: '',
      lang: $rdoLang(),
      source: 'emailbind',
      validCode: '',
      username: ''
    });
    var formErr = ref({});

    // 获取验证码组件
    var validCode = ref();

    // 邮箱输入框
    function usernameInput(params) {
      for (var key in formErr.value) {
        formErr.value[key] = '';
      }
      reset();
      validCode.value.reset();
      form.value.validCode = '';
    }

    // 判断是否存在空格
    function hasSpace(str) {
      return /\s/g.test(str);
    }
    // 去除复制粘贴中的空格
    var handlePaste = function handlePaste(event) {
      var clipboardData = event.clipboardData || window.clipboardData;
      var pastedData = clipboardData.getData('text/plain').replace(/\s+/g, '');
      clipboardData.setData('text/plain', pastedData); // 去除空格后重新设置剪贴板的内容
    };
    // 去除输入中出现的空格
    var handleInputUsername = function handleInputUsername() {
      if (hasSpace(form.value.username)) {
        form.value.username = form.value.username.replace(/\s+/g, ''); // 去除空格
      }
    };
    var closeDialog = function closeDialog() {
      for (var key in form.value) {
        if (key === 'uuid') {
          form.value[key] = 'dental-emailbind-' + VueCookieNext.getCookie('user_id');
        } else if (key === 'lang') {
          form.value[key] = $rdoLang();
        } else if (key === 'source') {
          form.value[key] = 'emailbind';
        } else {
          form.value[key] = '';
        }
      }
      for (var _key in formErr.value) {
        formErr.value[_key] = '';
      }
      reset();
      validCode.value.reset();
      formRef.value.resetFields();
      dialogVisible.value = false;
    };
    var confirmDialogRef = ref(false);
    var relieve = function relieve() {
      confirmDialogRef.value.dialogVisible = true;
    };
    var onSubmit = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(formEl) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (formEl) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.next = 4;
              return formEl.validate(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(valid, fields) {
                  var _yield$info$bindSilde, result, status;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (!valid) {
                          _context.next = 9;
                          break;
                        }
                        submitLoading.value = true;
                        _context.next = 4;
                        return info.bindSilde(form.value);
                      case 4:
                        _yield$info$bindSilde = _context.sent;
                        result = _yield$info$bindSilde.result;
                        status = _yield$info$bindSilde.status;
                        if (status === 'success') {
                          XlMessage({
                            type: 'success',
                            message: $t('messages.successEdit')
                          });
                          $getInfo();
                          closeDialog();
                        } else {
                          $formErr(result, formErr.value);
                        }
                        submitLoading.value = false;
                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2, _x3) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function onSubmit(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var reset = function reset() {
      captcharef.value.resetCaptcha();
      aliVerifyResult.value = {};
      hasSendVerifyCode = false;
    };

    // 阿里云验证码组件ref
    var captcharef = ref(null);
    // 阿里云验证码验证结果
    var aliVerifyResult = ref({});
    // 判断是否已发送过验证码
    var hasSendVerifyCode = false;
    var getCode = function getCode(value, callbacks) {
      for (var key in formErr.value) {
        formErr.value[key] = '';
      }
      form.value.validCode = '';
      // 当用户发送验证码成功后没有收到验证码需要重新获取时，需要重置验证码组件，如下
      // 切记，当发送验证码成功后将hasSendVerifyCode设置为true
      if (hasSendVerifyCode === true) {
        // 若验证码曾成功发出过，再次点击获取则重置验证码滑动组件
        reset();
      }
      captcharef.value.aliyunCaptchaVerifyState(function (state, res) {
        // 判断验证结果，state为true时会返回 验证参数
        if (state) {
          aliVerifyResult.value = res; // 该参数会在后续提交接口使用
          // 将返回的验证码鉴权参数与服务端请求合理接口拼接
          form.value = _objectSpread(_objectSpread({}, form.value), {}, {
            username: form.value.username
          }, res);
          form.value.template = 'validCode.changeInfo'; // 短信模板
          // 向接下来的请求的headers中添加x-auth-token  (已存入parameter)，若为登录后操作则不需要。
          info.userValidate(form.value).then(function (resRol) {
            if (resRol.status === 'success') {
              console.log('验证码发送成功 ');
              XlMessage({
                type: 'success',
                message: $t('验证码发送成功')
              });
              hasSendVerifyCode = true;
              callbacks(false);
            } else {
              $formErr(resRol.result, formErr.value);
              // 若获取验证码接口报错用户异常则直接重置验证码
              captcharef.value.resetCaptcha();
              aliVerifyResult.value = {};
              hasSendVerifyCode = false;
              callbacks(true);
            }
          }, function (error) {
            console.log(error);
            callbacks(true);
          });
        } else {
          if (res.validType) {
            formErr.value.validType = res.validType;
          }
          callbacks(true);
        }
      });
    };
    expose({
      dialogVisible: dialogVisible
    });
    return function (_ctx, _cache) {
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_el_form = _resolveComponent("el-form");
      var _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createBlock(_unref(XlDialog), {
        "destroy-on-close": "",
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return dialogVisible.value = $event;
        }),
        title: _unref($t)('personalInformation.passWord.mailReplace'),
        width: "400px",
        "before-close": closeDialog
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_form, {
            "inline-message": "",
            model: form.value,
            rules: rules.value,
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                prop: "username",
                error: formErr.value.username
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_unref(XlInput), {
                    modelValue: form.value.username,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return form.value.username = $event;
                    }),
                    onFocus: usernameInput,
                    onInput: handleInputUsername,
                    onPaste: handlePaste,
                    placeholder: _unref($t)('personalInformation.passWord.placeholderEmail')
                  }, null, 8, ["modelValue", "placeholder"])];
                }),
                _: 1
              }, 8, ["error"]), _withDirectives(_createVNode(_component_el_form_item, {
                error: formErr.value.validType
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_unref(XLCaptcha), {
                    ref_key: "captcharef",
                    ref: captcharef,
                    scene: "register",
                    "product-key": "passport"
                  }, null, 512)];
                }),
                _: 1
              }, 8, ["error"]), [[_vShow, captcharef.value && captcharef.value.showCaptcha]]), _createVNode(_component_el_form_item, {
                prop: "validCode",
                error: formErr.value.validCode
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_unref(XlCountDown), {
                    ref_key: "validCode",
                    ref: validCode,
                    modelValue: form.value.validCode,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return form.value.validCode = $event;
                    }),
                    onClick: getCode,
                    class: "m10"
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }, 8, ["error"])];
            }),
            _: 1
          }, 8, ["model", "rules"]), _createVNode(_component_el_row, {
            class: "footer"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(XlButton), {
                onClick: closeDialog
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_unref($t)('button.cancel')), 1)];
                }),
                _: 1
              }), _createVNode(_unref(XlButton), {
                type: "primary",
                loading: submitLoading.value,
                onClick: _cache[2] || (_cache[2] = function ($event) {
                  return onSubmit(formRef.value);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_unref($t)('button.determine')), 1)];
                }),
                _: 1
              }, 8, ["loading"])];
            }),
            _: 1
          }), _ctx.$store.state.userInfo.phone && _ctx.$store.state.userInfo.email ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            class: "relieve",
            onClick: relieve
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref($t)('personalInformation.passWord.unBinding')), 1)];
            }),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(confirmDialog, {
            ref_key: "confirmDialogRef",
            ref: confirmDialogRef,
            onSuccessOut: _cache[3] || (_cache[3] = function ($event) {
              return closeDialog();
            }),
            typeConfirm: "email"
          }, null, 512)];
        }),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
};